var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssistantTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9,10c-0.4-0.4-0.8-0.7-1.3-0.8C14.4,8.7,15,7.8,15,6.8c0-1.5-1.2-2.7-2.7-2.7S9.7,5.4,9.7,6.8 c0,1,0.6,1.9,1.4,2.3c-0.6,0.2-1.1,0.6-1.5,1.1C8.8,9.3,7.9,8.7,6.8,8.3C8.1,7.8,9,6.5,9,5c0-2-1.7-3.7-3.7-3.7C3.3,1.3,1.6,3,1.6,5 c0,1.5,0.9,2.8,2.2,3.3C1.6,9,0,11,0,13.4v0.8c0,0.3,0.2,0.5,0.5,0.5h9.6c0.3,0,0.5-0.2,0.5-0.5v-0.3h4.9c0.3,0,0.5-0.2,0.5-0.5 v-0.8C16,11.6,15.6,10.7,14.9,10z M12.3,5.1c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7S11.4,5.1,12.3,5.1z  M2.6,5c0-1.5,1.2-2.7,2.7-2.7C6.8,2.3,8,3.5,8,5S6.8,7.7,5.3,7.7C3.8,7.7,2.6,6.5,2.6,5z M9.6,13.7H1v-0.3C1,11,2.9,9.1,5.3,9.1 c2.4,0,4.3,1.9,4.3,4.3V13.7z M15,12.9h-4.5c-0.1-0.6-0.2-1.2-0.5-1.8c0.5-0.8,1.3-1.2,2.3-1.2c0.7,0,1.4,0.3,1.9,0.8 s0.8,1.2,0.8,1.9V12.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantTask);
export default __webpack_public_path__ + "static/media/assistant-task.62b5f9a2ce14d64e0f3b23c98d05bb84.svg";
export { ForwardRef as ReactComponent };